import { Avatar, Stack, Typography } from "@mui/material";
import { Box } from "@mui/system";
import Episode from "../models/episode";

interface EpisodeTileProps {
  episode: Episode;
  episodeNumber: number;
}

export const EpisodeTile: React.FC<EpisodeTileProps> = (props) => {
  const episode = props.episode;

  const color = episode.featuring[0].themeColour;

  return (
    <Stack direction={"row"} alignItems={"center"} padding={2}>
      <Avatar sx={{ bgcolor: color }}>{props.episodeNumber}</Avatar>
      <Box padding={1} />
      <Stack direction={"column"}>
        <Typography textTransform="uppercase" fontWeight="bold">
          {episode.name}
        </Typography>
        <Typography variant="body2" fontFamily="monospace" color="primary">
          {"ft." + episode.featuring.map((character) => " " + character.name)}
        </Typography>
        <Typography variant="body1" style={{ whiteSpace: "pre-wrap" }}>
          {episode.plot}
        </Typography>
      </Stack>
    </Stack>
  );
};
